/**
 * 依恋风格解释工具 - 通俗易懂版
 */

/**
 * 获取依恋风格的名称和翻译
 */
function getStyleName(style) {
  const styleNames = {
    'Secure': {
      name: '安全型',
      nameEn: 'Secure'
    },
    'Preoccupied': {
      name: '焦虑型',
      nameEn: 'Preoccupied'
    },
    'Dismissing': {
      name: '回避型',
      nameEn: 'Dismissing'
    },
    'Fearful': {
      name: '恐惧型',
      nameEn: 'Fearful'
    }
  };

  return styleNames[style] || { name: '未确定', nameEn: 'Undetermined' };
}

/**
 * 获取依恋风格的简洁描述和建议
 */
function getDescriptionAndSuggestions(style) {
  const descriptions = {
    // 安全型
    Secure: {
      description: "你在感情中能够轻松建立信任，善于沟通，乐于分享内心世界。你既能自然地依赖伴侣，也能给对方提供温暖的支持。你的关系通常稳定而令人满足，这种安全感让你在感情中游刃有余。",
      suggestions: "继续保持开放诚实的沟通方式，多关注伴侣的情感需求。尝试共同规划未来生活，或探索新的共同兴趣爱好，让感情保持新鲜活力。"
    },
    // 焦虑型
    Preoccupied: {
      description: "你在感情中非常重视亲密关系，渴望与伴侣建立深度情感连接，但经常担心对方不够爱你或感情会变淡。你敏感细心，对伴侣的微小变化都很在意，希望持续获得关注和情感确认。",
      suggestions: "学习识别自己的情绪变化，尝试坦诚表达内心的需求，同时给自己和伴侣适度的个人空间。可以尝试写日记记录情绪，或练习简单的放松呼吸来帮助平静心情。"
    },
    // 回避型
    Dismissing: {
      description: "你重视独立性和个人空间，不习惯过于依赖他人，喜欢保持自主和自给自足。你理性务实，但在感情中可能难以完全敞开心扉或表达内心的情感需求。",
      suggestions: "尝试每天主动分享一些生活小事，逐步练习更多情感表达。想想什么让你感到舒适自在，然后从小事开始与伴侣建立信任互动，慢慢加深感情连接。"
    },
    // 恐惧型
    Fearful: {
      description: "你对亲密关系既渴望又恐惧，希望得到真挚的爱，但也担心受伤、被抛弃或被过度控制。这种矛盾的心情让你在关系中常常表现出接近又退缩的不一致行为。",
      suggestions: "与伴侣建立清晰的沟通规则，勇敢表达自己的感受和个人界限。尝试从小步骤开始建立信任，比如分享一些安全的个人经历，逐渐增加情感亲密度。"
    }
  };

  // 默认值
  let description = "你的爱情模式似乎处于变化中，可能在不同关系中表现不同。";
  let suggestions = "反思自己在感情中的行为模式，尝试找到平衡亲密和独立的方式。";

  if (descriptions[style]) {
    description = descriptions[style].description;
    suggestions = descriptions[style].suggestions;
  }

  return { description, suggestions };
}

/**
 * 获取依恋风格的详细分析内容 - 通俗易懂版
 */
function getDetailedInfo(style) {
  const detailedInfo = {
    // ========== 安全型 ==========
    Secure: {
      characteristics: [
        "在亲密关系中感到轻松自在，像在家一样舒适自然",
        "容易信任伴侣，能在依赖和独立之间找到平衡",
        "能够坦诚表达自己的情感需求，不会藏着掖着",
        "尊重伴侣的独立性，给对方足够的个人空间",
        "善于以平和的方式处理关系中的分歧和矛盾"
      ],
      anxietyAnalysis: [
        "你的焦虑感得分很低，这说明你在感情中很有安全感。你不会整天担心伴侣不爱你或者会离开你，你相信自己是值得被爱的，也相信伴侣对你是真心的。",
        "就算偶尔有小矛盾或者暂时见不到面，你也能保持平静，因为你知道这些都很正常，不会影响你们的关系。"
      ],
      avoidanceAnalysis: [
        "你的回避感得分很低，说明你很享受和伴侣在一起的亲密时光。你愿意敞开心扉，分享自己的想法和感受，也乐于接受伴侣的关心和帮助。",
        "对你来说，和喜欢的人亲近是一件自然而舒服的事情，不需要刻意保持距离。"
      ],
      relationshipPattern: [
        "作为安全型的人，你的感情生活通常比较稳定和谐。你就像一个很好的舞伴，既能和伴侣跳得很亲近，又能保持各自的节奏。",
        "你懂得什么时候该亲密，什么时候该给对方空间。你们之间有良好的沟通，有相互的支持，还有深厚的信任。遇到问题时，你们能够一起面对，一起解决。"
      ],
      detailedSuggestions: [
        "继续保持开放坦诚的沟通，有什么事都说出来，不要闷在心里",
        "可以尝试和伴侣一起规划未来，比如讨论以后的居住城市、家庭计划等",
        "留意关系中有没有变得太一成不变，适时制造一些小惊喜或者一起尝试新事物",
        "发挥你的优势，帮助身边感情遇到困扰的朋友，你的经验对他们很有价值",
        "欣赏伴侣的成长和变化，支持对方追求自己的梦想"
      ]
    },

    // ========== 焦虑型 ==========
    Preoccupied: {
      characteristics: [
        "非常渴望和伴侣建立深深的亲密关系，但总是担心自己不够好",
        "对伴侣的一举一动和情绪变化都特别敏感",
        "需要经常得到确认和肯定，才能感到安心",
        "特别害怕被拒绝、被抛弃或者不被在乎",
        "感情中容易出现较大的情绪起伏"
      ],
      anxietyAnalysis: [
        "你的焦虑感得分较高，这意味着你经常担心感情会出问题。你可能总是忍不住想确认伴侣是不是真的爱你，会不会突然不喜欢你了。",
        "当感觉不安全的时候，你可能会反复琢磨伴侣说的每一句话、做过的每一个动作，甚至把一些小事情想得很严重。这种担心可能和过去的经历有关，让你对感情缺乏信心。"
      ],
      avoidanceAnalysis: [
        "你的回避感得分很低，说明你一点都不害怕亲近。相反，你非常渴望和伴侣建立最紧密的连接，愿意全身心投入感情，也乐于依赖伴侣给你的支持。",
        "你可能会对伴侣表现出比较强烈的依恋，有时甚至希望每时每刻都在一起。"
      ],
      relationshipPattern: [
        "作为焦虑型的人，你的感情往往充满了浓烈的情绪。你渴望和伴侣达到心灵相通的境界，常常担心对方不像你爱他那样深爱着你。",
        "当感到不安时，你可能会不自觉地想要得到更多的确认，比如发消息问对方在干嘛，或者希望伴侣不断表达对你的爱。这种模式虽然体现了你的深情，但如果对方需要更多个人空间时，可能会产生矛盾。"
      ],
      detailedSuggestions: [
        "当你又开始胡思乱想时，试着先深呼吸几次，让自己冷静下来再行动",
        "可以写日记记录自己的情绪变化，慢慢发现哪些事情容易触发你的不安",
        "试着给自己和伴侣一些独处的时间，发展自己的兴趣爱好，这样不会把所有情感需求都压在对方身上",
        "有不安的时候，坦诚告诉伴侣你的感受，但也要听听对方的想法",
        "如果焦虑感很强，可以考虑找心理咨询师聊聊，他们能帮你更好地理解自己的情绪"
      ]
    },

    // ========== 回避型 ==========
    Dismissing: {
      characteristics: [
        "特别看重个人的独立和自由，觉得靠自己最好",
        "不习惯依赖别人，也不太会开口寻求帮助",
        "倾向于把自己的感受藏在心里，不愿意表达出来",
        "和伴侣在一起时喜欢保持一定的情感距离",
        "对太亲密的举动会感到不自在"
      ],
      anxietyAnalysis: [
        "你的焦虑感得分很低，说明你不太担心被拒绝或者被抛弃。你对自己有足够的信心，不会整天猜疑伴侣的想法。",
        "这种沉稳让你在感情中能够保持冷静，不会因为一些小事就情绪波动。但有时候也可能会忽略一些关系中需要关注的情感信号。"
      ],
      avoidanceAnalysis: [
        "你的回避感得分较高，这意味着你更习惯和他人保持一定距离。你不太愿意分享内心深处的想法和感受，觉得什么事情都靠自己解决更好。",
        "在你看来，太依赖别人是一种弱点，所以宁可自己扛着也不愿意开口求助。这种模式可能会让伴侣觉得你不太好接近。"
      ],
      relationshipPattern: [
        "作为回避型的人，你在感情中喜欢保持适度的距离，强调各自的独立性。你不太擅长直接说出自己的感受，也不习惯主动寻求伴侣的安慰。",
        "当伴侣想要更多的亲密接触或者深入交流时，你可能会本能地想要退后。这种方式虽然让你感到安全，但可能会让伴侣觉得被疏远了。"
      ],
      detailedSuggestions: [
        "试着主动和伴侣分享一些小的事情，比如今天遇到的有趣的事",
        "当伴侣问你感觉怎么样时，试着说出具体的感受，而不只是说\"还行\"",
        "想想为什么不愿意依赖别人，是不是觉得开口求助就是软弱",
        "多倾听伴侣的感受，尝试给予一些回应，就算只是说\"我理解了\"也有帮助",
        "如果想要关系更进一步，可以考虑找心理咨询师，帮助你学会在保持独立的同时建立更亲密的关系"
      ]
    },

    // ========== 恐惧型 ==========
    Fearful: {
      characteristics: [
        "心里很想要亲密关系，但又特别害怕受伤",
        "对伴侣既有强烈的吸引，又保持着很高的警惕",
        "内心经常充满矛盾和纠结",
        "既担心被抛弃，又害怕被控制得太紧",
        "在关系中常常表现出想靠近又退缩的矛盾行为"
      ],
      anxietyAnalysis: [
        "你的焦虑感得分较高，说明你非常渴望和伴侣建立亲密关系，但同时又很担心被拒绝或者不被真正喜欢。",
        "你可能会对伴侣的一些小变化过度敏感，有时候甚至会把中性的行为理解成负面的。这种高度警觉的状态会让你很容易情绪波动，给感情带来额外的压力。"
      ],
      avoidanceAnalysis: [
        "你的回避感得分也较高，说明虽然你内心渴望亲密，但同时也深深地害怕它。你很难完全信任一个人，担心表露真实的自己会受到伤害。",
        "这种矛盾的心态让你陷入两难：想要靠近，却又忍不住想要逃离。别人可能会觉得你忽冷忽热，难以捉摸。"
      ],
      relationshipPattern: [
        "作为恐惧型的人，你的感情生活往往比较复杂。你内心既渴望被爱被理解，又害怕投入后会被伤害。",
        "这可能导致你在想要亲近的时候突然退缩，或者在保持距离的时候又觉得孤独。这种起伏不定的模式会让双方都感到困惑和疲惫。"
      ],
      detailedSuggestions: [
        "如果这种矛盾感很强，建议找专业的心理咨询师聊聊，他们能帮助你处理深层的信任问题",
        "当你感到矛盾时，试着搞清楚自己到底在怕什么，是怕被抛弃，还是怕失去自我",
        "和伴侣坦诚地聊聊你的感受，包括你的害怕和担忧，诚实的沟通能减少误会",
        "从小事开始练习信任，比如先分享一件不太敏感的事情，慢慢建立安全感",
        "学会关爱自己，不要把所有情感需求都寄托在伴侣身上，自己也要有自己的生活和支持系统"
      ]
    },

    // ========== 未确定型/混合型 ==========
    Default: {
      characteristics: [
        "在不同的关系中会展现出不同的特点",
        "你的依恋风格可能正在成长变化中",
        "情感反应和关系模式比较复杂多样",
        "可能同时具备多种依恋风格的一些特征",
        "在不同的情况下会表现不同的依恋行为"
      ],
      anxietyAnalysis: [
        "你的焦虑感得分处于中间位置，说明你在感情中时而觉得安全，时而又会担心被拒绝。",
        "这种变化可能和具体的人、所处的阶段或者当时的状态有关。观察自己在什么情况下会感到不安，什么情况下会感到踏实，能帮助你更好地理解自己。"
      ],
      avoidanceAnalysis: [
        "你的回避感得分也显示出复杂的特点，说明你对亲密关系的态度不是固定的。有时候你很享受亲近，有时候你又想保持距离。",
        "这种灵活性可能是你对不同情况的适应，但也可能反映出你内心的不确定感。"
      ],
      relationshipPattern: [
        "你的感情模式比较多样，可能会因为不同的伴侣或者不同的关系阶段而表现出不同的特点。",
        "你可能在某些关系中很投入，在另一些关系中又比较保守。这种多变性可能是你在探索适合自己的亲密方式。"
      ],
      detailedSuggestions: [
        "回想一下在不同关系中的表现，看看有没有什么规律，比如在什么人面前会感到安心",
        "想想在感情中你最在乎什么，是安全感、是自由、是被理解还是其他什么",
        "注意那些影响你感受的过去经历，它们可能在不知不觉中影响着你现在对待感情的方式",
        "和伴侣保持开放的沟通，特别是在你需求发生变化的时候",
        "给自己一些时间，不用急着给自己贴标签，慢慢探索适合自己的亲密方式"
      ]
    }
  };

  return detailedInfo[style] || detailedInfo.Default;
}

export { getStyleName, getDescriptionAndSuggestions, getDetailedInfo };
